import { createAction, props } from '@ngrx/store';
import type { PostThirdpartyV1Data } from '@integration/api-client/feh';
import type { ScLinkField } from '@core/jss-models';

const prefix = '[Sustainability Rabobank]';

export const submitRabobankForm = createAction(
  `${prefix} Submit form`,
  props<{
    payload: PostThirdpartyV1Data;
  }>()
);

export const submitRabobankFormSuccess = createAction(
  `${prefix} Submit form success`
);

export const setRedirectUrl = createAction(
  `${prefix} Set redirect url`,
  props<{
    redirectUrl: ScLinkField;
  }>()
);
